var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1964,
    height: 1964,
    viewBox: "0 0 1964 1964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1675.93 287.544C1491.82 103.433 1242.11 0 981.737 0C721.364 0 471.655 103.433 287.544 287.544C103.433 471.655 0 721.364 0 981.737C0 1242.11 103.433 1491.82 287.544 1675.93C471.655 1860.04 721.364 1963.47 981.737 1963.47C1242.11 1963.47 1491.82 1860.04 1675.93 1675.93C1860.04 1491.82 1963.47 1242.11 1963.47 981.737C1963.47 721.364 1860.04 471.655 1675.93 287.544ZM981.737 1831.89C512.971 1831.89 131.585 1450.51 131.585 981.737C131.585 512.963 512.963 131.585 981.737 131.585C1450.51 131.585 1831.89 512.963 1831.89 981.737C1831.89 1450.51 1450.51 1831.89 981.737 1831.89Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M833.788 1187.57L531.915 885.705L438.873 978.747L833.788 1373.66L1522.54 684.909L1429.5 591.867L833.788 1187.57Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclecheck);
export default __webpack_public_path__ + "static/media/circle check.84e6f7cea3b3704e83547370838b5e0a.svg";
export { ForwardRef as ReactComponent };